import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconGithub16 = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	fill: "none",
	viewBox: "0 0 16 16",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M8 1.2a7 7 0 0 0-2.213 13.642c.35.064.478-.152.478-.338 0-.166-.006-.606-.01-1.19-1.946.423-2.357-.938-2.357-.938-.318-.81-.777-1.024-.777-1.024-.636-.434.048-.426.048-.426.702.05 1.072.722 1.072.722.624 1.07 1.638.76 2.037.581.064-.452.244-.76.444-.935-1.554-.177-3.188-.778-3.188-3.46 0-.764.273-1.389.72-1.878-.072-.177-.312-.889.069-1.853 0 0 .588-.188 1.925.718A6.7 6.7 0 0 1 8 4.585c.595.003 1.194.08 1.753.236 1.336-.906 1.923-.718 1.923-.718.382.964.142 1.676.07 1.853.448.49.72 1.114.72 1.878 0 2.689-1.638 3.28-3.197 3.454.251.216.475.643.475 1.296 0 .936-.008 1.69-.008 1.92 0 .188.126.406.48.337A7 7 0 0 0 8 1.2",
		clipRule: "evenodd"
	})
});
const ForwardRef = forwardRef(SvgIconGithub16);
export default ForwardRef;
